import { Box, Button, Grid, makeStyles, TextField } from "@material-ui/core"
import { AssociatedEmailChannel } from "@root/store/types"
import React from "react"

export interface Props {
  onAssociate: (email: AssociatedEmailChannel) => void
}

const useStyles = makeStyles({
  button: {
    alignSelf: "center",
  },
})

const AssociatedEmail: React.FC<Props> = ({ onAssociate }) => {
  const [address, setAddress] = React.useState("")
  const classes = useStyles()

  return (
    <Box
      component="form"
      data-qa-selector="associated-email-form"
      onSubmit={(ev) => {
        ev.preventDefault()
        onAssociate({ platform: "email", address })
        setAddress("")
      }}
    >
      <Grid container spacing={2}>
        <Grid item sm={10} xs={12}>
          <TextField
            fullWidth
            data-qa-selector="email-input"
            type="email"
            required
            id="email-id"
            label="Email Address"
            value={address}
            onChange={(ev) => setAddress(ev.target.value)}
          />
        </Grid>
        <Grid item sm={2} xs={12} className={classes.button}>
          <Button
            fullWidth
            data-qa-selector="submit"
            type="submit"
            variant="contained"
            disabled={!address}
          >
            Register
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}

export default AssociatedEmail
